export const calendarModals = {
  common: {
    cancel: "إلغاء",
  },
  arrival: {
    title: "قواعد التقويم",
    loading: "جارٍ تحميل الإعدادات…",
    daysTitle: "أيام الوصول والمغادرة",
    canArrive: "يمكن الوصول",
    canDepart: "يمكن المغادرة",
    daysHint:
      "مع <b>تحديد الكل</b> لا توجد أي قيود. إذا سمحت بالوصول يوم الاثنين والمغادرة يوم الأحد فقط، فسيستمر كل حجز أسبوعًا كاملًا بالضبط.",
    summaryAny: "يمكن الوصول والمغادرة في أي يوم",
    summaryArrival: "الوصول في {n} من 7 أيام",
    summaryDeparture: "المغادرة في {n} من 7 أيام",
    summaryRestricted: "مقيّد: {detail}",
    cutoffTitle: "إغلاق بيع اليوم بعد ساعة محددة",
    cutoffToggle: "إغلاق بيع اليوم نفسه تلقائيًا",
    cutoffToggleHint: "أثناء إيقافه، تقبل الوصول لليوم نفسه في أي وقت.",
    cutoffFrom: "اعتبارًا من الساعة",
    cutoffTz: "توقيت مكان إقامتك",
    cutoffTzNow: "هناك الساعة {time}",
    cutoffHintPre: "كل يوم، عند الساعة ",
    cutoffHintMid: " بتوقيت ",
    cutoffHintPost:
      "، ستتوقف عن استقبال الحجوزات لليوم نفسه. تبقى الأيام التالية مفتوحة كالمعتاد.",
    cutoffSummaryOn: "يُغلق البيع كل يوم عند الساعة {time}",
    cutoffSummaryOff: "تقبل الوصول لليوم نفسه في أي وقت",
    turnoverTitle: "وقت التحضير",
    turnoverQuestion: "كم ليلة تحتاج بين ضيف والذي يليه؟",
    turnoverOptNone: "لا شيء",
    nights: "{count} ليلة | {count} ليالٍ",
    custom: "مخصّص",
    customLabel: "الليالي",
    customAside: "على كل جانب، حتى 7",
    turnoverSummaryNone: "يمكن الوصول في اليوم نفسه الذي يغادر فيه ضيف آخر",
    turnoverSummarySet: "احجز {nights} بين ضيف والذي يليه",
    turnoverLegacySummaryAfter: "تُطبَّق حاليًا بعد المغادرة فقط · احفظ لتغطية الجانبين",
    turnoverLegacySummaryBefore: "تُطبَّق حاليًا قبل الوصول فقط · احفظ لتغطية الجانبين",
    turnoverLegacyNoteAfter: "هذه القاعدة من الإصدار السابق وتحجب حاليًا بعد المغادرة فقط، وليس قبل الوصول. عند الحفظ ستُطبَّق على الجانبين، وسنُعلمك أولًا بعدد الليالي التي ستُغلق.",
    turnoverLegacyNoteBefore: "هذه القاعدة من الإصدار السابق وتحجب حاليًا قبل الوصول فقط، وليس بعد المغادرة. عند الحفظ ستُطبَّق على الجانبين، وسنُعلمك أولًا بعدد الليالي التي ستُغلق.",
    exampleLabel: "مثال",
    exampleCaption: "حجز يبدأ في الـ15 وينتهي في الـ18",
    legendStay: "الإقامة",
    legendPrep: "التحضير",
    legendFree: "معروض للبيع",
    turnoverMoveHint: "ينتقل الحظر تلقائيًا إذا تغيّرت التواريخ ويختفي إذا أُلغي الحجز.",
    impactClosePre: "سيتم إغلاق ",
    impactClosePost: " في قنواتك.",
    impactOpenPre: "سيتم فتح ",
    impactOpenPost: ".",
    impactRetry: "اضغط «حفظ القواعد» مرة أخرى لتطبيقه.",
    fallbackHost: "مكان إقامتك",
    saving: "جارٍ الحفظ…",
    applyYes: "نعم، طبّق",
    saveRules: "حفظ القواعد",
    loadError: "تعذّر تحميل الإعدادات.",
    saveSuccess: "تم حفظ قواعد التقويم وإرسالها إلى قنواتك.",
    saveError: "تعذّر الحفظ.",
    saveConfigError: "تعذّر حفظ الإعدادات.",
    linkedTitle: "بيع الشقة كاملة",
    linkedSummaryOff: "تُباع هذه الوحدة بمفردها",
    linkedSummaryOn: "تبيع المسكن كاملاً · تشمل {count} غرفة | تبيع المسكن كاملاً · تشمل {count} غرف",
    linkedSummaryChild: "جزء من {parent}",
    linkedRooms: "{count} غرفة | {count} غرف",
    linkedToggle: "تفعيل كشقة كاملة للإعلان",
    linkedToggleHint: "للوحدة التي تؤجّر المسكن كاملاً. بعد ذلك اختر الغرف التي تشملها.",
    linkedQuestion: "ما الغرف التي تشملها؟",
    linkedAll: "تحديد الكل",
    linkedNone: "إلغاء تحديد الكل",
    linkedIsParent: "تُباع بالفعل كشقة كاملة",
    linkedGuests: "{count} ضيف | {count} ضيوف",
    linkedExampleCaption: "حُجزت «{room}» من 19 إلى 21",
    linkedExampleRoom: "الغرفة 1",
    linkedLegendClosed: "تُغلق تلقائياً",
    linkedHint: "والعكس صحيح: إذا حُجزت الشقة كاملة، تُغلق جميع غرفها. وإذا أُلغي الحجز أو تغيّرت تواريخه، يُفتح كل شيء تلقائياً، وفي قنواتك أيضاً. طالما بقي الحجز قائماً، لا يمكن فتح هذه الإغلاقات يدوياً.",
    linkedChildPre: "هذه الغرفة جزء من ",
    linkedChildPost: ". إذا حُجزت، تُغلق تلك الشقة الكاملة في تلك الليالي؛ وإذا حُجزت الشقة كاملة، تُغلق هذه الغرفة تلقائياً. يمكن تغيير ذلك من قواعد تقويم الشقة الكاملة.",
    linkedConflicts: "يوجد بالفعل {count} بيع مزدوج بين الشقة الكاملة وغرفها. راجعه: | يوجد بالفعل {count} بيوع مزدوجة بين الشقة الكاملة وغرفها. راجعها:",
    linkedNeedsRooms: "حدّد غرفة واحدة على الأقل ضمن الشقة الكاملة.",
    linkedSaveError: "تعذّر حفظ بيع الشقة كاملة.",
    linkedAlertTitle: "«{unit}» تصبح الشقة الكاملة",
    linkedAlertBody: "إذا حُجزت، ستُغلق الغرف التي تحددها تلقائياً هنا وفي قنواتك (Booking وAirbnb…). وإذا حُجزت أيّ غرفة منها، ستُغلق هذه الوحدة في تلك الليالي. وإذا أُلغي الحجز، يُفتح كل شيء تلقائياً.",
    linkedPartialSave: "تم حفظ بيع الشقة كاملة، لكن لم تُحفظ القواعد الأخرى. حاول مرة أخرى.",
  },
  weekend: {
    title: "إعدادات الأسعار",
    subtitle: "ستظهر هذه المعلومات كل ليلة، ما لم تخصّصها حسب التاريخ.",
    loading: "جارٍ تحميل الإعدادات…",
    plTitle: "الأسعار مُدارة بواسطة PriceLabs",
    plDesc1:
      "هذا العقار لديه إدارة الأسعار الديناميكية مفعّلة عبر PriceLabs. تُحدَّث الأسعار تلقائيًا حسب الطلب والموسم والإشغال.",
    plDesc2: "لتعديل أسعار نهاية الأسبوع، افعل ذلك مباشرة من لوحة PriceLabs الخاصة بك.",
    plOpen: "فتح PriceLabs",
    basePriceTitle: "السعر الأساسي",
    basePriceLabel: "لكل ليلة — يُطبَّق كل الأيام",
    customization: "التخصيص",
    weekendPriceTitle: "سعر نهاية الأسبوع",
    toggleOff: "تعطيل سعر نهاية الأسبوع",
    toggleOn: "تفعيل سعر نهاية الأسبوع",
    appliesTo: "يُطبَّق أيام:",
    weekendLabel: "نهاية الأسبوع",
    infoHint: "سيُطبَّق على الـ<strong>500 يوم القادمة</strong> في الأيام المحددة.",
    disabledText: "ستستخدم أيام نهاية الأسبوع السعر الأساسي البالغ",
    confirmTitle: "تعطيل سعر نهاية الأسبوع؟",
    confirmDescPre: "ستعود الأيام إلى السعر الأساسي البالغ",
    confirmDescPost: "تلقائيًا.",
    disabling: "جارٍ التعطيل…",
    confirmDisable: "نعم، عطّل",
    saving: "جارٍ الحفظ…",
    saveChanges: "حفظ التغييرات",
    diffEqual: "مثل الأساسي",
    diffUp: "+{pct}% مقابل الأساسي",
    diffDown: "{pct}% مقابل الأساسي",
    loadError: "خطأ في تحميل إعدادات الأسعار",
    disableSuccess: "تم تعطيل سعر نهاية الأسبوع. تعود الأيام إلى السعر الأساسي.",
    disableError: "خطأ في تعطيل سعر نهاية الأسبوع",
    saveSuccess: "تم حفظ الأسعار بنجاح",
    saveError: "خطأ في الحفظ",
  },
};
